import React from 'react';
import { Link } from 'react-router-dom';

function BlogThreeItemFour({ thumb, meta, title, category, slug, img }) {
    // If slug is defined, we link to the product details.
    // If slug is undefined, we link to the category page.
    const linkPath = slug ? `/products/${category}/${slug}` : `/products/${category}`;

    return (
        <div className="col-xl-4 col-md-6 col-12">
            {/* <Link to={linkPath}> */}
            <div className="single-news-card" style={{height: "350px"}}>
                <div
                    className="featured-thumb bg-cover"
                    style={{ backgroundImage: `url(${img})` }}
                />
                <div className="post-content">
                    {/* <div className="post-meta d-flex">
                            <div className="post-date ml-2">
                                <span>{meta}</span>
                            </div>
                        </div> */}

                    <h3 style={{ textTransform: 'capitalize' }}>
                        {/* <Link to={linkPath}> */}
                        {title.replace(/-/g, ' ')}
                        {/* </Link> */}
                    </h3>

                    {/* <Link
                        className="read-btn"
                        to={linkPath}
                    >
                        Read More
                    </Link> */}
                </div>
            </div>
            {/* </Link> */}
        </div>
    );
}

export default BlogThreeItemFour;